var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M22 6.14V19H2V6.14l10 10 10-10zM20.31 5L12 13.31 3.69 5H20.3z"}));
}

Mail.defaultProps = {"width":"24","height":"24","aria-label":"Mail","viewBox":"0 0 24 24"};

module.exports = Mail;

Mail.default = Mail;
